import React, { Fragment, useState } from "react";

import "./Footer.scss";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";
import { HiOutlineExternalLink } from "@react-icons/all-files/hi/HiOutlineExternalLink";

import WorldMap from "../../../public/assets/images/map.webp";
import { NavLink } from "react-router-dom";
import { navLinks, socialLinks } from "../../data/data";
import PrivacyPolicy from "../privacypolicy/PrivacyPolicy";

const getNavLinks = () => {
  return navLinks.map((item, index) => {
    let link = ``;
    if (item === "Home") {
      link = `/`;
    } else if (item === "Login") {
      link = `https://app.seizurecarenet.com/`;
    } else {
      link = `/${item.toLowerCase()}`;
    }
    return (
      <Fragment key={index}>
        <NavLink to={link}>
          <span className="link">
            {item}
            {item === "Login" && (
              <HiOutlineExternalLink className="external-link-icon" size={20} />
            )}
          </span>
        </NavLink>
        {index !== navLinks.length - 1 && "|"}
      </Fragment>
    );
  });
};

const Footer = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const socialIcons = [
    <FaFacebook className="icon-fb" />,
    <FaLinkedin className="icon-in" />,
    <FaYoutube className="icon-yt" />,
  ];

  return (
    <div className="footer-container">
      <div className="footer-top-container">
        <div className="address">
          <div className="address-text">
            <p>
              <b>SeizureCare</b>
            </p>
            <div className="countries-list">
              <a href="https://seizurecarenet.com">USA</a>
              <a href="https://seizurecarenet.in">India</a>
            </div>
          </div>
          <img className="world-map" alt="SeizureCare" src={WorldMap} />
        </div>
        <div className="footer-links">{getNavLinks()}</div>
        <div className="socials-container">
          {socialLinks.map((url, index) => (
            <a href={url}>{socialIcons[index]}</a>
          ))}
        </div>
      </div>
      <div className="footer-bottom-container">
        Copyright &#169; 2024 SeizureCare |
        <button
          className="privacy-notice-button"
          onClick={() => setShowPrivacyPolicy(true)}
        >
          Privacy Notice
        </button>
      </div>
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
    </div>
  );
};

export default Footer;
